import './Follow.css';

export default function Follow() {
    return (<div id="follow" className="section">
        <h1>Follow</h1>
        <p>
            Coming soon...
        </p>
        
        <div class="follow-sites">
            <FollowSite
                name="Instagram"
                img={process.env.PUBLIC_URL + '/site_logos/instagram.png'}
                url="https://www.instagram.com/divisionleagueband/"></FollowSite>
            
            <FollowSite
                name="YouTube"
                img={process.env.PUBLIC_URL + '/site_logos/youtube.png'}
                url="https://youtube.com"></FollowSite>

            <FollowSite
                name="Spotify"
                img={process.env.PUBLIC_URL + '/site_logos/spotify.png'}
                url="https://spotify.com"></FollowSite>
        </div>
    </div>)
}

function FollowSite(props) {
    return (<div className="follow-site">
        <a href={props.url} target="_blank">
            <img src={props.img}></img>
        </a>
    </div>)
}